export default __webpack_public_path__ + "static/media/portuur.3d39fdf4.svg";